import { showWizardStep, syncProgressSemantics, wizardPhase } from "./navigation"

export const typeformNavigation = {
  handleKeyboard(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      const activeEl = document.activeElement
      if (activeEl && (activeEl.tagName === "TEXTAREA" || activeEl.tagName === "SELECT")) return
      if (activeEl && activeEl.type === "file") return

      event.preventDefault()
      this.next()
    }
  },

  advanceAfterScreenCapture() {
    if (this.currentValue !== 3) return
    if (this.selectedValidationMethod() !== "screen_share_capture") return
    this.next()
  },

  async next() {
    if (this.isAdvancing) return
    if (!this.validateCurrentStep()) return
    if (this.currentValue >= this.totalSteps - 1) return

    if (this.currentValue === 1) {
      const button = this.stepTargets[this.currentValue]?.querySelector(
        'button[data-action*="typeform#next"]'
      )
      this.isAdvancing = true
      if (button) button.disabled = true

      try {
        if (!await this.validateAirlineProgramme()) return
        this.currentValue++
        this.showStep(this.currentValue)
      } finally {
        this.isAdvancing = false
        if (button) button.disabled = false
      }
      return
    }

    this.currentValue++
    this.showStep(this.currentValue)
  },

  back() {
    if (this.currentValue === 0) return
    this.currentValue--
    this.showStep(this.currentValue)
  },

  showStep(index) {
    showWizardStep(this.stepTargets, index)
    const firstInput = this.stepTargets[index]?.querySelector("input, select, textarea")
    if (firstInput) setTimeout(() => firstInput.focus(), 400)

    this.updateProgress()
    this.updateNavigationButtons()
    this.updateWizardStepper()
    if (index === 3) {
      this.syncUploadStepVisibility()
      this.syncScreenShareExpected()
    }
    this.syncReviewSummaryFromForm()
    if (index === 4) {
      this.syncReviewSummaryFromForm()
      this.syncReviewSubmitEnabled()
    }
  },

  goToStep(event) {
    const raw = event.params?.step
    if (raw == null || raw === "") return
    const index = parseInt(raw, 10)
    if (Number.isNaN(index) || index < 0 || index >= this.totalSteps) return
    this.currentValue = index
    this.showStep(this.currentValue)
  },

  wizardPhase() {
    return wizardPhase(this.currentValue)
  },

  updateWizardStepper() {
    syncProgressSemantics(this.progressTabTargets, this.wizardPhase())
  },

  updateProgress() {
    const pct = ((this.currentValue + 1) / this.totalSteps) * 100
    if (this.hasProgressTarget) {
      this.progressTarget.style.width = `${pct}%`
    }
  },

  updateNavigationButtons() {
    this.backButtonTargets.forEach((button, index) => {
      button.classList.toggle("invisible", index === this.currentValue && this.currentValue === 0)
    })
  }
}
